import Row from 'react-bootstrap/Row';
import React from 'react';
import { useTranslation } from 'react-i18next';
import riffrLogoBlack from '../../assets/icons/riffrLogoBlack.png';
import './footerNav.scss';
import constants from '../../utils/constants';

const { screens } = constants;

const FooterNav = () => {
  const { t } = useTranslation();
  return (
    <div className="footerNav">
      <div className="d-none d-sm-block">
        <Row>
          <img src={riffrLogoBlack} alt="riffrLogoBlack" width="20" height="20" className="align-self-center" />
          <a className="nav-link" href={screens.blog}><span className="app-value">{t('homepage.blog')}</span></a>
          <a className="nav-link" href={screens.contactUs}><span className="app-value">{t('homepage.contact')}</span></a>
          <a className="nav-link" href={screens.privacyPolicy}><span className="app-value">{t('homepage.privacyPolicy')}</span></a>
          <a className="nav-link" href={screens.terms}>
            <span
              className="app-value"
            >
              {t('homepage.termsOfUse')}
            </span>
          </a>
        </Row>
      </div>
      <div className="d-block d-sm-none">
        <Row className="no-gutters nav-links-container justify-content-between">
          <img src={riffrLogoBlack} alt="riffrLogoBlack" width="20" height="20" className="align-self-center nav-link-logo" />
          <span>
            <a className="nav-link" href={screens.blog}><span className="app-value">{t('homepage.blog')}</span></a>
          </span>
          <span>
            <a className="nav-link" href={screens.contactUs}><span className="app-value">{t('homepage.contact')}</span></a>
          </span>
          <span>
            <a className="nav-link" href={screens.privacyPolicy}><span className="app-value">{t('homepage.privacyPolicy')}</span></a>
          </span>
          <span>
            <a className="nav-link text-right" href={screens.terms}>
              <span
                className="app-value"
              >
                {t('homepage.termsOfUse')}
              </span>
            </a>
          </span>
        </Row>
      </div>
    </div>
  );
};

export default FooterNav;
